import { authSlice } from '@wellesley/auth'
import { useDispatch, useSelector } from 'react-redux'
import {
  useCurrentUserUpdate,
  useGetApiV1AccountsProfileQuery,
} from '@wellesley/user'
import { updateUser } from '@wellesley/host-remote/api/actions'

const useUpdateMyProfile = () => {
  const dispatch = useDispatch()
  const isLogged = useSelector(authSlice.selectors.selectIsAuthenticated)

  useGetApiV1AccountsProfileQuery(
    {
      htmlContent: false,
    },
    {
      skip: !isLogged,
    },
  )

  useCurrentUserUpdate({
    onUpdate: (user) => dispatch(updateUser(user)),
  })
}

export default useUpdateMyProfile
